module.exports = __webpack_public_path__ + "img/jeep-camera.b60452e1.svg";